.flyer { position: relative; overflow: hidden; isolation: isolate; border-radius: var(--radius); background: var(--fill); }
.flyer::before { content: ""; position: absolute; inset: -30px; z-index: -1; background: var(--img) center / cover; filter: blur(24px); opacity: .55; }
.flyer img { display: block; width: 100%; max-height: 380px; object-fit: contain; }
